// extracted by mini-css-extract-plugin
module.exports = {"fullHeight":"ErrorBoundary_fullHeight__1bzic"};